(() => {
  /**
   * Handle the devil character spine animations
   */
  class DevilCharacter extends PIXI.Container {
    constructor() {
      super();
      // asset name
      this._devilSpineName = "DevilCharacter";

      // devil spine asset
      this._devilCharacterSpine = null;

      // firewave animated sprite
      this._firewaveAnimations = [];

      this._devilShootEmitterContainer = null;

      // idle loop counter for the devil(play blink anim 1 in 4 times)
      this._idleLoopCounter = 0;

      // emitter asset that shoots fire from the devil
      this._devilShootEmitters = {
        Red: null,
        Green: null,
        Magenta: null,
      };

      this.idle = false;
    }

    /**
     * Initialise the class
     */
    initialise() {
      messageBus.subscribe("spinner:GameConfigEvent", () => {
        this._onLayoutComplete();
      });
      Reflex.registerEventHandler("orientationChange", this._orientationChange.bind(this));
    }

    /**
     * Grab the devil character spine assets
     */
    _onLayoutComplete() {
      this.parent.visible = true; // WHY DO I HAVE TO DO THIS? BECAUSE YOURE RETARDED :)

      this._devilShootEmitterContainer = resourceManager.get("devilCharacterContainer:devilShootEmitterContainer");

      this._devilCharacterSpine = resourceManager.createObject("spine", this._devilSpineName, this, {
        name: this._devilSpineName,
        defaultAnimation: "LeftDevil_Idle01",
        scaleX: 0.3,
        scaleY: 0.3,
        x: 0,
        y: 0,
      });

      //set up the emitters for each colour
      ["Red", "Green", "Magenta"].forEach((colour) => {
        this._devilShootEmitters[colour] = particleManager.createEmitter(
          `throwParticle${colour}`,
          this._devilShootEmitterContainer,
          0,
          0,
          false
        );
        this._devilShootEmitters[colour].particleEmitter.emit = false;
      });

      // set up firewave animations
      const numReels = 5;
      for (let i = 0; i < numReels; i++) {
        const firewaveAnim = resourceManager.createObject(
          "movie",
          `firewaveReel${i}`,
          `devilCharacterContainer:firewaveReelContainer${i}`,
          {
            definition: "firewave",
            anchor: 0.5,
            loop: false,
          }
        );
        firewaveAnim.visible = false;
        firewaveAnim.gotoAndStop(0);
        firewaveAnim.onComplete = function () {
          firewaveAnim.gotoAndStop(0);
          firewaveAnim.visible = false;
        };
        this._firewaveAnimations.push(firewaveAnim);
      }

      this.idleLoop();
    }

    /**
     * Play counter shoot anim
     */
    _counterShoot() {
      this._devilCharacterSpine.play("LeftDevil_CounterShoot");
    }

    /**
     * Play dance anim
     */
    dance(loops = 0) {
      this._devilCharacterSpine.spineObject.state.clearListeners();
      let loopCount = 0;
      this._devilCharacterSpine.play("LeftDevil_Dance_Level1", true, 0);
      if (loops !== -1) {
        this._devilCharacterSpine.spineObject.state.addListener({
          complete: (entry) => {
            if (entry.animation.name === "LeftDevil_Dance_Level1") {
              loopCount++;
              if (loopCount >= loops) {
                this.idleLoop();
              }
            }
          },
        });
      }
    }

    /**
     * Play fire wave anim
     */
    async fireWave() {
      soundManager.play("fireWave");

      const anim = systemData.isLandscape ? "LeftDevil_FireWave_Desktop" : "LeftDevil_FireWave_Portrait";
      this._devilCharacterSpine.play(anim, false, 0, () => this.idleLoop());
      await gsap.delayedCall(1.3);
      gameController.firewaveActive = true;
      gameController.injectCoinsAndGems();
      this._firewaveAnimations.map((firewaveAnim) => {
        firewaveAnim.visible = true;
        firewaveAnim.play();
      });
    }

    /**
     * Loop the sleep animation
     */
    sleepAnimation() {
      this.idle = true;
      this._devilCharacterSpine.play("LeftDevil_Sleep_Into", false, 0, () => {
        this._devilCharacterSpine.play("LeftDevil_Sleep_Loop", true);
      });
    }

    /**
     * Leave sleep animation
     */
    leaveSleepAnimation() {
      this.idle = false;
      this._devilCharacterSpine.play("LeftDevil_Sleep_Out", false, 0, () => {
        this._devilCharacterSpine.play("LeftDevil_Idle04_lock", false, 0, () => {
          this.idleLoop();
        });
      });
    }

    /**
     * Play frustrated anim
     */
    frustrated() {
      this._devilCharacterSpine.play("LeftDevil_Frustrated");
    }

    /**
     * alternate frustrate anim
     */
    centreDevilLinkFrustrate() {
      this._devilCharacterSpine.play("LeftDevil_Idle03", false, 0, () => {
        this.idleLoop();
      });
    }

    /**
     * Play idle loop anim
     */
    idleLoop() {
      this._devilCharacterSpine.play("LeftDevil_Idle01", false, 0, () => {
        this._idleLoopCounter++;
        if (this._idleLoopCounter === 4) {
          this._idleBlink();
        } else {
          this.idleLoop();
        }
      });
    }

    /**
     * Do devil "idle_02" - for big win animations
     */
    bigWinAnimation() {
      this._devilCharacterSpine.play("LeftDevil_Idle02", true);
    }

    /**
     * Play idle blink anim
     */
    _idleBlink() {
      this._idleLoopCounter = 0;
      this._devilCharacterSpine.play("LeftDevil_Idle01_Blink", false, 0, () => this.idleLoop());
    }

    /**
     * Play nudge anim when haven't landed devil symbol
     */
    async nudge() {
      musicManager.playDevilLaughSound();
      soundManager.play("devilNudge");

      const centreGlobalPos = resourceManager.get("slotContainer:reelContainer:reel7").getGlobalPosition();
      const localDevilShootEndPos = this._devilShootEmitterContainer.toLocal(centreGlobalPos);

      const animName = systemData.isLandscape ? "LeftDevil_Nudge_Desktop" : "LeftDevil_Nudge_Portrait";
      this._devilCharacterSpine.play(animName, false, 0, () => this.idleLoop());

      const animInfo = this._devilCharacterSpine.spineObject.spineData.animations.find(
        (anim) => anim.name === animName
      );
      const duration = animInfo.duration;

      await this.shootParticle(localDevilShootEndPos, duration);
    }

    /**
     * Shoot the devil characer flame over to the collect meter
     */
    async shootToCollectMeter() {
      const animName = "LeftDevil_CounterShoot";
      this._devilCharacterSpine.play(animName, false, 0, () => this.idleLoop());

      const centreGlobalPos = resourceManager
        .get("collectMeterContainer:toCollectMeter:textContainer:toCollectTextDisplay")
        .getGlobalPosition();
      const localDevilShootEndPos = this._devilShootEmitterContainer.toLocal(centreGlobalPos);

      const animInfo = this._devilCharacterSpine.spineObject.spineData.animations.find(
        (anim) => anim.name === animName
      );
      const duration = animInfo.duration;

      await this.shootParticle(localDevilShootEndPos, duration);
    }

    /**
     * Shoot particle to location
     */
    async shootParticle(locationToShoot, duration) {
      await new Promise((resolve) => {
        setTimeout(async () => {
          soundManager.play("devilFlamePoint");
          const emitterToPlay = this._devilShootEmitters.Red;
          emitterToPlay.alpha = 1;
          emitterToPlay.particleEmitter.emit = true;
          await gsap.to(emitterToPlay, { x: locationToShoot.x, y: locationToShoot.y, duration: 0.5 });
          gsap.to(emitterToPlay, { alpha: 0, duration: 0.2 }).then(() => {
            emitterToPlay.x = 0;
            emitterToPlay.y = 0;
          });
          resolve();
        }, duration * 0.6 * 1000);
      });
    }

    /**
     * Play lock wiggle animation
     */
    playLockWiggle() {
      this._devilCharacterSpine.play("LeftDevil_Idle04_lock", false, 0, () => this.idleLoop());
    }

    /**
     * Handle orientation change
     * @param {boolean} isLandscape
     */
    _orientationChange(isLandscape) {}
  }

  resourceManager.registerObjectType(
    "devilCharacter",
    () => new DevilCharacter(),
    initialise,
    () => []
  );
})();
